import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
const HEADER_HEIGHT = 56;

const PrivateMenuCampanha = () => {
    const navigate = useNavigate(); // NOVO: hook para navegação

    const { id: campaignId } = useParams();
    return (
        <div
            style={{
                background: "#f8f9fa",
                borderBottom: "1px solid #e6e6e6",
                padding: "12px 24px",
                display: "flex",
                gap: 16,
                alignItems: "center",
                position: "sticky",
                top: HEADER_HEIGHT,
                zIndex: 1100,
                overflowX: window.innerWidth <= 768 ? "auto" : "visible",
                whiteSpace: window.innerWidth <= 768 ? "nowrap" : "normal",
            }}
        >

            <a href={"#"} onClick={e => navigate(`/campanha/${campaignId}`)}>  <button className="btn btn-outline-success">Visão</button></a>
            <a href={"#"} onClick={e => navigate(`/campanha/${campaignId}/contas-vinculadas`)}><button className="btn btn-outline-success">Contas Vinculadas</button></a>
            <a href={"#"} onClick={e => navigate(`/campanha/${campaignId}/Grupos`)} ><button className="btn btn-outline-success">Grupos</button></a>
            <a href={"Analisedash"} onClick={e => navigate(`/campanha/${campaignId}/Analisedash`)} ><button className="btn btn-outline-success">Análise</button></a>
            <a href="/Leadscoring"><button className="btn btn-outline-success">Leadscoring</button></a>
            <a href="/Calendario"><button className="btn btn-outline-success">Calendário</button></a>
            <a href="/Adicionarauto"><button className="btn btn-outline-success">Automações</button></a>
            <a href={"#"} onClick={e => navigate(`/campanha/${campaignId}/operacoes`)} ><button className="btn btn-outline-success">Operações</button></a>
        </div>
    );
};

export default PrivateMenuCampanha;
